import { useRecoilValue, useResetRecoilState } from 'recoil'
import { useParams } from 'react-router'
import { CustomBtn, JoinSubmitWrap, NoticeFeeText } from 'src/styles/views/join/JoinSubmit'

import useAPI from 'src/hooks/useAPI'
import PageCalling from 'src/components/common/Loading'
import { PartnerInfo } from 'src/types/type'
import {
  AllCheckState,
  CertCheckState,
  TermsAgreeState,
  MvnoCheckValue,
  PartnerState,
  RecoilStateList,
  TelNumState,
  uiVerifyStyle,
} from 'src/recoil/ui'
import { getTermsAgree } from 'src/service/join'

const JoinSubmit = (props: any): JSX.Element => {
  const { pcode } = useParams()
  const { submit } = props

  const PartnerData: PartnerInfo = useRecoilValue(PartnerState)
  const api = useAPI('SENDOTPVERFY')
  const { TelType, PhoneNum, CertNum, termsAgree, TransId, UserType } =
    useRecoilValue(RecoilStateList)
  const ResetPhoneNum = useResetRecoilState(TelNumState)
  const ResetCertCheck = useResetRecoilState(CertCheckState)
  const ResetTermsAgree = useResetRecoilState(TermsAgreeState)
  const ResetTerms = useResetRecoilState(AllCheckState)
  const { cashSpace, verifyBtn, cancelBtn } = useRecoilValue(uiVerifyStyle)
  const mvnoCheckValue = useRecoilValue(MvnoCheckValue)

  const { mutateAsync: JoinRequest, isLoading } = api.useSetMutation({
    TeleType: TelType.toString(),
    PNumber: PhoneNum,
    Pcode: pcode,
    TransactionID: TransId,
    CryptoNumber: CertNum,
    AuthType: 'Add',
    TermsAgree: getTermsAgree(termsAgree, TelType, mvnoCheckValue),
    CALLTYPE: UserType,
  })

  return (
    <JoinSubmitWrap>
      <PageCalling active={isLoading} />
      <CustomBtn
        className="btn_signup"
        {...verifyBtn}
        backgroundColor={verifyBtn.backgroundColor}
        onClick={() => submit.join(JoinRequest)}
      >
        {PartnerData.ButtonMsgAfter}
      </CustomBtn>
      <CustomBtn
        className="btn_cancel"
        {...cancelBtn}
        fontColor={'#d8d8d8'}
        backgroundColor={cancelBtn.backgroundColor}
        onClick={() => {
          ResetPhoneNum()
          ResetCertCheck()
          ResetTerms()
          ResetTermsAgree()
        }}
      >
        취소
      </CustomBtn>
      <NoticeFeeText
        cashSpace={cashSpace}
        fontColor={PartnerData.FontColor}
        fontSize={PartnerData.FontSize}
        dangerouslySetInnerHTML={{ __html: PartnerData.NotiContent }}
      />
    </JoinSubmitWrap>
  )
}
export default JoinSubmit
